import {TemplateModel} from "../../shared/helpers/template-model";
import {autoinject} from "aurelia-dependency-injection";
import {AppSettings} from "../../app-settings";
import { AuthService } from "../../authentication/auth-service";

@autoinject
export class TemplateManager extends Backbone.Collection<TemplateModel> {

    public model = TemplateModel;

    constructor(private authService: AuthService) {
        super();
    }

    public getTemplate(id: string, documentSku?: string): Promise<TemplateModel> {
        id = id.toLowerCase();
        if (id === "statute_section") { id = "statute"; }

        if (!documentSku) {
            documentSku = this.authService.AppUser.Sku;
        }

        let template = this.where({ id: id })[0];
        template = template || this.createTemplateModel(id, documentSku);

        return new Promise<TemplateModel>((resolve, reject) => {
            if (template.Loaded) {
                resolve(template);
            } else {
                template.load().then(() => {
                    resolve(template);
                }).catch(reject);
            }
        });
    }

    public removeTemplate(id: string): void {
        const template: TemplateModel = this.where({ id: id })[0];
        this.remove(template);
    }

    private createTemplateModel(id: string, documentSku: string): TemplateModel {
        const model = new TemplateModel({ id: `${documentSku}-${id}` });
        id = id.toLowerCase();
        documentSku = documentSku.toLowerCase();
        model.Path = `assets/templates/${documentSku}/${id}.html`;
        this.add(model);
        return model;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/template-manager.ts